import AppSearchAPIConnector from '@elastic/search-ui-app-search-connector';

export const searchConnector = () => {
  return new AppSearchAPIConnector({
    searchKey:
      process.env.GATSBY_ELASTIC_SEARCH_KEY || 'Missing elastic search key',
    engineName:
      process.env.GATSBY_ELASTIC_ENGINE || 'Missing elastic engine name',
    endpointBase:
      process.env.GATSBY_ELASTIC_ENDPOINT || 'Missing elastic endpoint',
  });
};
